
import DialogTemplate from '@/_components/dialog/template/template.vue'
import FormResponseViewer from '@/views/Project/Form/components/formResponseViewer.vue'
import { patchRequest, postRequest } from '@/plugins/api-axios'
import { serialise } from 'kitsu-core'
import ProjectMixin from '@/_mixins/project'
import RiskLevelMixin from '@/views/Project/ch/mixins/risk.mixin'
import FormResponseMixin from '@/views/Project/ch/mixins/formResponse.mixin'
import PrintResponseButton from '@/views/Project/Form/components/printResponseButton.vue'
import InlineUser from '@/views/User/components/inlineUser/inlineUser.vue'
import type { FormResponseStatus } from '@/views/Project/Form/types/form'

export default {
    name: 'FormResponseViewerDialog',
    components: {
        InlineUser,
        DialogTemplate,
        FormResponseViewer,
        PrintResponseButton,
    },
    mixins: [FormResponseMixin, RiskLevelMixin, ProjectMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
        contractorFormResponse: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formResponse: null,
            status: this.contractorFormResponse?.status as FormResponseStatus,
            message: '',
            showMessage: false,
        }
    },
    computed: {
        deviceTimeZone() {
            return this.guessTimezone()
        },
        formResponseExportFilename() {
            if (!this.contractorFormResponse) {
                return ''
            }

            if (!this.contractorFormResponse.submittedBy.data) {
                return `${this.contractorFormResponse.form.data.name}-${this.formatDate(
                    this.contractorFormResponse.createdAt,
                    this.deviceTimeZone,
                    'DD.MM.YYYY HH:mm'
                )}`
            }

            return `${this.contractorFormResponse.form?.data.name}-${
                this.contractorFormResponse.submittedBy?.data.name
            }-${this.formatDate(
                this.contractorFormResponse.submittedAt,
                this.deviceTimeZone,
                'DD.MM.YYYY HH:mm'
            )}`
        },
    },
    methods: {
        async update(status: FormResponseStatus) {
            let payload = serialise(this.contractorFormResponse.type, {
                id: this.contractorFormResponse.id,
                status,
            })
            await patchRequest(
                this.contractorFormResponse.links.self,
                this.headersmixins,
                payload.data
            )
            this.status = status
            this.$emit('close', { refresh: true })
        },
        handleFormResponseLoaded(formResponse: any) {
            this.formResponse = formResponse
        },
        handleReject() {
            this.update('rejected')
            // wait for BE to complete the update Rejected response before sending the email
            setTimeout(this.sendReminder, 1000)
        },
        async sendReminder() {
            if (!this.formResponse) {
                return
            }

            let kind = this.status === 'rejected' ? 'rejected' : 'updateResponse'
            let recipients = []
            let toUser = (item: any) => ({ type: item.type, id: item.id })
            if (kind === 'rejected') {
                recipients = this.contractorFormResponse.readAccess.data.map(toUser)
            } else {
                recipients = this.contractorFormResponse.writeAccess.data.map(toUser)
            }

            let payload = serialise('contractorFormResponseEmail', {
                kind,
                message: this.message || null,
                languageId: this.formResponse.languageId,
                response: {
                    data: {
                        type: 'contractorFormResponse',
                        id: this.contractorFormResponse.id,
                    },
                },
                recipients: {
                    data: recipients,
                },
            })

            await postRequest(
                `${this.contractorBaseUrl}/contractorFormResponseEmails`,
                this.headersmixins,
                payload.data
            )

            this.message = ''
            this.showMessage = false
            let messageRef = this.$refs.messageRef as HTMLElement
            messageRef?.blur()
        },
    },
}
